import axios from "axios";
import { getAuthToken } from "./authService";

const API_URL = process.env.REACT_APP_AUTH_SERVICE_URL || 'http://localhost:8081';

const userService = {
  getAllUsers: async () => {
    const token = getAuthToken();
    try {
      const response = await axios.get(`${API_URL}/api/user/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Failed to fetch users");
    }
  },

  getUserCount: async () => {
    const token = getAuthToken();
    try {
      const response = await axios.get(`${API_URL}/api/user/count`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Failed to fetch user count");
    }
  },

  deleteUser: async (userId) => {
    const token = getAuthToken();
    try {
      const response = await axios.delete(`${API_URL}/api/user/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Failed to delete user");
    }
  },

  toggleUserStatus: async (userId, enabled) => {
    const token = getAuthToken();
    try {
      const response = await axios.put(`${API_URL}/api/user/${userId}/status`, { enabled }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Failed to update user status");
    }
  },

  manualResendVerification: async (userId) => {
    const token = getAuthToken();
    try {
      const response = await axios.post(`${API_URL}/api/user/${userId}/resend-verification`, {}, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Failed to resend verification email");
    }
  }
};

export default userService;
